// extracted by mini-css-extract-plugin
export default {"receiptValidation":"uploadSaleReceiptForm_receiptValidation__YnKYS"};